import { useNavigate } from 'react-router-dom';
import { AnimatePresence, m } from 'motion/react';
import Button from './ui/Button';
import logoWhite from '../assets/logo-bandi-white.svg';
import logoGrey from '../assets/logo-bandi-grey.svg';
import locales from '../locales.json';
import { ACTIONS, BRAND, PHOTO } from '../constants/homeAnimations';

const { HOME_TEXTS } = locales;

const SIDE_BY_SIDE = '(min-width: 900px) and (orientation: landscape)';

const IntroImageComponent = ({ children }) => {
  const navigate = useNavigate();

  return (
    <m.section className="hero" initial="initial" animate="visible" exit="exit">
      {/* Fotka je vlastni vrstva, jinak by odjizdela i s obsahem nad sebou. */}
      <m.div className="hero__photo" variants={PHOTO} />

      <div className="hero__panel">
        <picture className="hero__picture">
          <source media={SIDE_BY_SIDE} srcSet={logoGrey} />
          <m.img
            className="hero__brand"
            variants={BRAND}
            initial="initial"
            animate="visible"
            exit="exit"
            src={logoWhite}
            alt={HOME_TEXTS.logoAlt}
          />
        </picture>

        <m.div
          className="hero__actions"
          variants={ACTIONS}
          initial="initial"
          animate="visible"
          exit="exit"
        >
          <Button variant="primary" block onClick={() => navigate('/verify-email')}>
            {HOME_TEXTS.registerButton}
          </Button>
        </m.div>
      </div>

      <AnimatePresence>{children}</AnimatePresence>
    </m.section>
  );
};

export default IntroImageComponent;
